// extracted by mini-css-extract-plugin
module.exports = {"HydratedDescription":"HydratedDescription_HydratedDescription__PxbSu"};